module.exports = __webpack_public_path__ + "static/media/paint.e9c6c331.png";